import { DeepPartial } from "react-hook-form"

import { Logger } from "shared/lib/Logger"
import { Floor } from "shared/types/Floor"

import z from "zod"

import { FloorSchemaTransform } from "../types/Floor"

export function getFloorComplete(
  floor: DeepPartial<Floor>
): Required<Floor> | undefined {
  const completeFloor: Required<Floor> | undefined = z.safeParse(
    FloorSchemaTransform,
    floor
  ).data

  if (!completeFloor) {
    Logger.error(
      "ValidationError",
      "unable to create optimistic response while creating floor"
    )
  }

  return completeFloor
}
